export enum PricingsComparedToRangeBlock {
  Root = 'PricingsComparedToRange',
}

export enum PricingsComparedToRangeElement {
  charts = 'charts',
}
